// extracted by mini-css-extract-plugin
export default {"status":"header-statistics_status__qBnDf","icon":"header-statistics_icon__dnATI"};